/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import {
  Avatar,
  Box,
  Checkbox,
  FormControlLabel,
  TableCell,
  TableRow,
  Typography,
} from '@mui/material';

import { getIcon } from '../../../../../../pages/horse/Horse/components/LocationsCard';
import { primary } from '../../../../../../utils/brandColors';
import { getLocationTypeDisplayName } from '../../../../../../utils/enumHelper';
import TaskOverviewCell from '../TaskOverviewCell';

export const TaskCalenderOverviewLocationCell = ({
  barnHorses,
  barnHorsesMap,
  classes,
  fullScreen,
  handleCalendarEventItemClick,
  handleOverviewItemClick,
  handleOverviewItemTaskStateChangeClick,
  overview,
  selectedBarnHorses,
  selectedDay,
  selectedLocation,
  setOpenQuickSelectMenu,
  setSelectedBarnHorses,
  setSelectedSlot,
  todayTimestamp,
}) => (
  <TableRow sx={classes.rowLocation}>

    {!fullScreen && (
      <TableCell
        sx={{
          ...classes.cellStickyNarrow,
          px: 0,
          borderBottom: `6px solid ${'var(--primary-unknown)'}`,
        }}
        style={{ '--primary-unknown': primary[500] }}
      >
        <FormControlLabel
          sx={{
            m: 0,
            p: 0,
            textAlign: 'center',
          }}
          control={(
            <Checkbox
              color="primary"
              onChange={(event) => setSelectedBarnHorses(!event.target.checked
                ? []
                : barnHorses.filter((bh) => bh.pingumTagId && barnHorsesMap[bh.pingumTagId]).map((bh) => bh.pingumTagId))}
              checked={selectedBarnHorses.length === (Object.keys(overview).length - 1)}
              inputProps={{ 'aria-labelledby': 'barn-horse-row-checkbox-all' }}
            />
          )}
          label="All"
          labelPlacement="top"
        />

      </TableCell>
    )}
    <TableCell
      sx={{
        ...classes.cellSticky,
        minWidth: '90px !important',
        maxWidth: '90px !important',
        width: fullScreen && '90px !important',
        left: fullScreen && '0 !important',
        borderBottom: `6px solid ${'var(--primary-unknown)'}`,
      }}
      style={{ '--primary-unknown': primary[500] }}
    >
      <Box
        sx={[{
          display: 'flex',
          justifyContent: 'flex-start',
        }, fullScreen
          ? { alignItems: 'flex-start' }
          : { alignItems: 'center' }, fullScreen
          ? { flexDirection: 'column' }
          : { flexDirection: 'row' }]}
      >
        <Avatar
          alt={selectedLocation.name}
          sx={{
            color: 'action.active',
            width: 35,
            height: 35,
          }}
        >{getIcon(selectedLocation)}
        </Avatar>
        <Box
          sx={[fullScreen
            ? { ml: 0 }
            : { ml: 1 }, fullScreen
            ? { width: 90 }
            : { width: 150 }]}
        >
          <Typography component="h3" noWrap sx={{ lineHeight: '18px' }}>{selectedLocation.name}</Typography>
          <Typography
            noWrap
            component="div"
            sx={{
              color: '#858585',
              fontSize: 14,
              lineHeight: '18px',
            }}
          >{getLocationTypeDisplayName(selectedLocation)}
          </Typography>
        </Box>
      </Box>
    </TableCell>
    {
      Object.keys(overview[selectedLocation.pingumTagId])
        .filter((day) => !selectedDay || day === selectedDay).map((day) => (
          <TableCell
            sx={{
              ...(day.toString() === todayTimestamp.toString()
                ? classes.cellHighlight
                : (day < todayTimestamp
                  ? classes.cellPast
                  : classes.cell)),
              minWidth: fullScreen && 'auto !important',
              maxWidth: fullScreen && '0 !important',
              borderBottom: `6px solid ${'var(--primary-unknown)'}`,
            }}
            key={`table-row-location-${day}`}
            onClick={() => {
              setOpenQuickSelectMenu(true);
              const dayAsDate = new Date(parseInt(day, 10));
              setSelectedSlot({
                start: dayAsDate,
                end: new Date(dayAsDate.getTime() + 86400000), // mimicks an all day event
                isBarnTask: true,
              });
            }}
            style={{ '--primary-unknown': primary[500] }}
          >
            <TaskOverviewCell
              items={overview[selectedLocation.pingumTagId][day]}
              onClick={handleOverviewItemClick}
              onClickCalendarEvent={handleCalendarEventItemClick}
              onTaskStateChange={handleOverviewItemTaskStateChangeClick}
              today={day.toString() === todayTimestamp.toString()}
              showCalendarEvents={false}
            />
          </TableCell>
        ))
    }
  </TableRow>
)
